import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Statistic,
	notification,
	Row,
	Col,
	Button,
	Modal,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import AddPlantEfficiency from "./AddPlantEfficiency";
import UpdatePlantEfficiency from "./UpdatePlantEfficiency";

const { Text } = Typography;

const ProductionEfficiencyReport = () => {
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [listEfficiency, setListEfficiency] = useState([]);
	const [openNewModal, setOpenNewModal] = useState(false);
	const [openUpdateModal, setOpenUpdateModal] = useState(false);
	const [plantEfficiencyId, setPlantEfficiencyId] = useState(undefined);

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Daily Plant Production",
			dataIndex: "plantProduction",
			key: "plantProduction",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Sum of Total CY",
			dataIndex: "totalCY",
			key: "totalCY",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Revenue",
			dataIndex: "revenue",
			key: "revenue",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Plant Efficiency CY",
			dataIndex: "plantEfficiencyCY",
			key: "plantEfficiencyCY",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
							color: value < 0 ? "#c71818ff" : "#13af1dff",
						}}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Plant Efficiency %",
			dataIndex: "plantEfficiencyPercentage",
			key: "plantEfficiencyPercentage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
							color: value < 0 ? "#c71818ff" : "#13af1dff",
						}}
						suffix={"%"}
					/>
				);
			},
		},
		{
			title: "Plant Efficiency $",
			dataIndex: "plantEfficiencyMoney",
			key: "plantEfficiencyMoney",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
							color: value < 0 ? "#c71818ff" : "#13af1dff",
						}}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const columns2 = [
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Sum of Total CY",
			dataIndex: "totalCY",
			key: "totalCY",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Revenue",
			dataIndex: "revenue",
			key: "revenue",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Plant Efficiency CY",
			dataIndex: "plantEfficiencyCY",
			key: "plantEfficiencyCY",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
							color: value < 0 ? "#c71818ff" : "#13af1dff",
						}}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Plant Efficiency %",
			dataIndex: "plantEfficiencyPercentage",
			key: "plantEfficiencyPercentage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
							color: value < 0 ? "#c71818ff" : "#13af1dff",
						}}
						suffix={"%"}
					/>
				);
			},
		},
		{
			title: "Plant Efficiency $",
			dataIndex: "plantEfficiencyMoney",
			key: "plantEfficiencyMoney",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
							color: value < 0 ? "#c71818ff" : "#13af1dff",
						}}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const columnsEfficiency = [
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Minimum Daily Production [CY]",
			dataIndex: "productionDailyCY",
			key: "productionDailyCY",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Production/MO [CY]",
			dataIndex: "productionMoCY",
			key: "productionMoCY",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Production Cost",
			dataIndex: "productionCost",
			key: "productionCost",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Daily Min Production Cost",
			dataIndex: "productionDailyCost",
			key: "productionDailyCost",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const expandedRowRender = (row) => {
		return (
			<Table columns={columns2} dataSource={row.dates} pagination={false} />
		);
	};

	useEffect(() => {
		getLogisticsList();
	}, [startDate, endDate, refresh]);

	useEffect(() => {
		getLastPlantEfficiency();
	}, [refresh]);

	const getLogisticsList = async () => {
		setLoading(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api + `/job/get/production/efficiency?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				let list = [];

				const plantEfficiency = await getPlantsEfficiency();

				const groupedPlant = data.payload.reduce((acc, item) => {
					if (!acc[`${item.plant}_${item.plantId}`]) {
						acc[`${item.plant}_${item.plantId}`] = [];
					}
					acc[`${item.plant}_${item.plantId}`].push(item);
					return acc;
				}, {});

				Object.entries(groupedPlant).map(([plant, dates]) => {
					let datesList = [];

					let revenueGlobal = 0;
					let plantEfficiencyCYGlobal = 0;
					let plantEfficiencyPercentageGlobal = 0;
					let plantEfficiencyMoneyGlobal = 0;

					dates.map((item, index) => {
						let revenue = 0;
						let plantEfficiencyCY = 0;
						let plantEfficiencyPercentage = 0;
						let plantEfficiencyMoney = 0;

						plantEfficiency.map((plant2, index2) => {
							const dateStart = plant2.createdAt
								? dayjs(plant2.createdAt)
								: null;
							const dateEnd = plant2.closedDate
								? dayjs(plant2.closedDate)
								: null;
							const currentDate = dayjs(item.date);

							//last register
							if (index2 === 0) {
								if (dateStart && !dateEnd) {
									if (
										currentDate.isAfter(dateStart) ||
										currentDate.isSame(dateStart, "day")
									) {
										const currentPlant = plant2.plants.find(
											(p) => p.plant._id === plant.split("_")[1]
										);

										if (currentPlant) {
											revenue = item.totalYards * currentPlant.productionCost;
											plantEfficiencyCY =
												item.totalYards - currentPlant.productionDailyCY;
											plantEfficiencyPercentage =
												(item.totalYards / currentPlant.productionDailyCY) *
												100;
											plantEfficiencyMoney =
												revenue - currentPlant.productionDailyCost;
										}
									}
								}
							} else {
								if (dateStart && dateEnd) {
									if (
										(currentDate.isAfter(dateStart) ||
											currentDate.isSame(dateStart, "day")) &&
										(currentDate.isBefore(dateEnd) ||
											currentDate.isSame(dateEnd, "day"))
									) {
										const currentPlant = plant2.plants.find(
											(p) => p.plant._id === plant.split("_")[1]
										);

										if (currentPlant) {
											revenue = item.totalYards * currentPlant.productionCost;
											plantEfficiencyCY =
												item.totalYards - currentPlant.productionDailyCY;
											plantEfficiencyPercentage =
												(item.totalYards / currentPlant.productionDailyCY) *
												100;
											plantEfficiencyMoney =
												revenue - currentPlant.productionDailyCost;
										}
									}
								}
							}
						});

						revenueGlobal += revenue;
						plantEfficiencyCYGlobal += plantEfficiencyCY;
						plantEfficiencyPercentageGlobal += plantEfficiencyPercentage;
						plantEfficiencyMoneyGlobal += plantEfficiencyMoney;

						datesList.push({
							index: index,
							key: index,
							totalCY: item.totalYards,
							date: item.date,
							revenue,
							plantEfficiencyCY,
							plantEfficiencyPercentage,
							plantEfficiencyMoney,
						});
					});

					plantEfficiencyPercentageGlobal =
						plantEfficiencyPercentageGlobal / dates.length;

					list.push({
						key: plant.split("_")[1],
						index: plant.split("_")[1],
						plantProduction: plant.split("_")[0],
						totalCY: dates.reduce((acc, item) => {
							return acc + item.totalYards;
						}, 0),
						dates: datesList,
						revenue: revenueGlobal,
						plantEfficiencyCY: plantEfficiencyCYGlobal,
						plantEfficiencyPercentage: plantEfficiencyPercentageGlobal,
						plantEfficiencyMoney: plantEfficiencyMoneyGlobal,
					});
				});

				setList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const getLastPlantEfficiency = async () => {
		const url = api + `/plantefficiency/get/last`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				let list = [];
				data.payload.plants.map((item, index) => {
					list.push({
						key: index,
						index: index,
						plant: item.plant.name,
						productionDailyCY: item.productionDailyCY,
						productionMoCY: item.productionMoCY,
						productionCost: item.productionCost,
						productionDailyCost: item.productionDailyCost,
					});
				});
				setListEfficiency(list);
				setPlantEfficiencyId(data.payload._id);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Error while trying to get last plant efficiency"
			);
			console.error(err.message);
			return null;
		}
	};

	const getPlantsEfficiency = async () => {
		try {
			const start = dayjs().startOf("year").format("YYYY-MM-DD");
			const end = dayjs().endOf("month").format("YYYY-MM-DD");

			const url =
				api + `/plantefficiency/get/dates?startDate=${start}&endDate=${end}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			if (data.success) {
				return data.payload;
			} else {
				return null;
			}
		} catch (err) {
			openNotification(
				"error",
				"Error",
				"Error while trying to get all plant efficiency"
			);
			console.error(err.message);
			return null;
		}
	};

	const handleNewModal = () => {
		setOpenNewModal((prev) => !prev);
	};
	const handleUpdateModal = () => {
		setOpenUpdateModal((prev) => !prev);
	};

	const onCompleteRegister = () => {
		handleNewModal();
		setRefresh((prev) => !prev);
	};

	const RenderNewModal = () => {
		return (
			<Modal
				title={`Add new plant efficiency`}
				open={openNewModal}
				onCancel={handleNewModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
			>
				<AddPlantEfficiency pcb={onCompleteRegister} />
			</Modal>
		);
	};

	const onFinishUpdate = async () => {
		handleUpdateModal();
		setRefresh((prev) => !prev);
	};

	const RenderUpdateModal = () => {
		return (
			<Modal
				title={`Update Days of Month for calculations`}
				open={openUpdateModal}
				onCancel={handleUpdateModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={600}
			>
				<UpdatePlantEfficiency
					pcb={onFinishUpdate}
					plantEfficiencyId={plantEfficiencyId}
				/>
			</Modal>
		);
	};

	const RenderTables = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Row gutter={16}>
					<Col span={18}>
						<Table
							columns={columnsEfficiency}
							dataSource={listEfficiency}
							pagination={{
								position: ["bottomRight"],
								defaultPageSize: 10,
								showSizeChanger: true,
							}}
							scroll={{
								x: "max-content",
							}}
							style={{
								minWidth: "100%",
							}}
						/>
					</Col>
					<Col>
						<Row gutter={[16, 16]}>
							<Col span={24}>
								<Button type="primary" size="large" onClick={handleNewModal}>
									Change Values
								</Button>
							</Col>
							<Col span={24}>
								<Button
									type="primary"
									size="large"
									danger
									onClick={handleUpdateModal}
								>
									Change Days
								</Button>
							</Col>
						</Row>
					</Col>
				</Row>
				<Table
					columns={columns}
					dataSource={list}
					expandable={{
						expandedRowRender,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "100%",
					}}
					// onRow={(record) => ({
					// 	style: {
					// 		background: "#7686bbff",
					// 	},
					// })}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderDates = () => {
		return (
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				dateFormat={"MM/DD/YYYY"}
				onRangeChange={onRangeChange}
			/>
		);
	};

	function getFlattenedHeaders(columns) {
		return columns.flatMap((col) => {
			const title = col.title;
			return title;
		});
	}

	function getFlattenedKeys(columns) {
		return columns.flatMap((col) => {
			return col.dataIndex || col.key || ""; // prefer dataIndex, fallback to key
		});
	}

	const handleExportXlsx = () => {
		// Step 1: Get headers
		let data = [];
		const headers = getFlattenedHeaders(columns);
		const keys = getFlattenedKeys(columns);
		const keysPlant = getFlattenedKeys(columns2);

		data.push(headers);

		list.map((item) => {
			let top = [];
			keys.map((i) => {
				top.push(item[i]);
			});
			data.push(top);

			let middle = [];
			item.dates.map((item2) => {
				keysPlant.map((j) => {
					middle.push(item2[j]);
				});
				data.push(middle);
				middle = [];
			});

			data.push([]);
		});

		const ws = XLSX.utils.aoa_to_sheet(data);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Production Efficiency");

		// Step 4: Export file
		XLSX.writeFile(wb, `57 Sales Report Production Efficiency.xlsx`);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={handleExportXlsx}
							loading={loading}
							disabled={list.length === 0}
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Production Efficiency" description="Report" type="large">
			<Flex vertical gap={"large"}>
				<RenderDates />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTables />}
			</Flex>
			{contextHolder}
			<RenderNewModal />
			<RenderUpdateModal />
		</Layout>
	);
};

export default ProductionEfficiencyReport;
